import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { style: {"height":"90vh"} }
const _hoisted_3 = { class: "mc innerEditAppointmentContent" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "fs20 ls1 mc centered fw600" }, "この調整ページでの日程調整一覧", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppointmentCardView = _resolveComponent("AppointmentCardView")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "PastAppointmentsModal",
    "content-class": "rad10 pad15 with_white_bg ofs shadowContent modalWide noscroll"
  }, {
    default: _withCtx(() => [
      _createElementVNode("a", {
        class: "dismiss",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissModal && _ctx.dismissModal(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
          width: "50",
          height: "50"
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          (_ctx.appos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appos, (appo, appoindex) => {
                  return (_openBlock(), _createBlock(_component_AppointmentCardView, {
                    key: `${appoindex}`,
                    appo: appo,
                    appoindex: appoindex
                  }, null, 8, ["appo", "appoindex"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ])
      ])
    ]),
    _: 1
  }))
}